import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

type DeleteMarketShopInventoryItemRequest = {
  id: number
  buildingId: number
}

type BulkActionResponse = {
  affected: number
  failed: number[]
}

const deleteMarketShopInventoryItem = async (
  data: DeleteMarketShopInventoryItemRequest,
): Promise<BulkActionResponse> => {
  const response = await authAPI.post<BulkActionResponse>('/market-shop/products/bulk', {
    action: 'delete',
    buildingId: data.buildingId,
    ids: [data.id],
  })
  return response.data
}

export const useDeleteMarketShopInventoryItem = () => {
  return useMutation({
    mutationFn: deleteMarketShopInventoryItem,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async ({ affected }) => {
      await resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
      if (affected > 0) {
        toastFactory.success('Item deleted successfully')
      } else {
        toastFactory.error('Failed to delete item')
      }
    },
  })
}
